import AltRouteIcon from "@mui/icons-material/AltRoute";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import BadgeIcon from "@mui/icons-material/Badge";
import CalculateIcon from "@mui/icons-material/Calculate";
import CampaignIcon from "@mui/icons-material/Campaign";
import CategoryIcon from "@mui/icons-material/Category";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloudIcon from "@mui/icons-material/Cloud";
import DataObjectIcon from "@mui/icons-material/DataObject";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import GavelIcon from "@mui/icons-material/Gavel";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import HomeIcon from "@mui/icons-material/Home";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import LoginIcon from "@mui/icons-material/Login";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MovieIcon from "@mui/icons-material/Movie";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PaletteIcon from "@mui/icons-material/Palette";
import PeopleIcon from "@mui/icons-material/People";
import PollIcon from "@mui/icons-material/Poll";
import PsychologyIcon from "@mui/icons-material/Psychology";
import ScienceIcon from "@mui/icons-material/Science";
import PublicIcon from "@mui/icons-material/Public";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import SettingsIcon from "@mui/icons-material/Settings";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import SortIcon from "@mui/icons-material/Sort";
import StarIcon from "@mui/icons-material/Star";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { SvgIconComponent } from "@mui/icons-material";

const iconMap: Record<string, SvgIconComponent> = {
  home: HomeIcon,
  countries: PublicIcon,
  users: PeopleIcon,
  profiles: BadgeIcon,
  support: SupportAgentIcon,
  calculator: CalculateIcon,
  terms: GavelIcon,
  banners: CampaignIcon,
  apprating: StarIcon,
  satisfactionsurvey: PollIcon,
  splashscreen: SlideshowIcon,
  sendpush: NotificationsActiveIcon,
  revalidation: VerifiedUserIcon,
  report: AssessmentIcon,
  onboard: LoginIcon,
  paths: AltRouteIcon,
  modules: ViewModuleIcon,
  digitalserviceplan: SubscriptionsIcon,
  marketingcloud: CloudIcon,
  manualinstructions: IntegrationInstructionsIcon,
  garage: DirectionsCarIcon,
  models: DirectionsCarFilledIcon,
  colors: PaletteIcon,
  ownersmanual: MenuBookIcon,
  pills: VideoLibraryIcon,
  pillscontent: MovieIcon,
  pillsordering: SortIcon,
  faq: HelpCenterIcon,
  faqsistem: SettingsIcon,
  faqcategory: CategoryIcon,
  faqquestion: QuestionAnswerIcon,
  ottotrialperiod: ScienceIcon,
  cognitivo: PsychologyIcon,
  manual: AutoStoriesIcon,
  transformjson: DataObjectIcon,
};

export function iconFor(name: string): SvgIconComponent {
  return iconMap[name.toLowerCase()] || ChevronRightIcon;
}
